/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import classnames from 'classnames';

export interface ICookieComplianceAcceptEssentialButton {
    reloading?: boolean;
    acceptEssentialCookiesButtonText?: string;
    acceptEssentialCookiesButtonAriaLabel?: string;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onClose(): void;
}

export const CookieComplianceAcceptEssentialButton: React.FC<ICookieComplianceAcceptEssentialButton> = ({
    reloading,
    acceptEssentialCookiesButtonText,
    acceptEssentialCookiesButtonAriaLabel,
    telemetryContent,
    onClose
}) => {
    const payLoad: IPayLoad = getPayloadObject('click', telemetryContent!, 'accept essential cookies');
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <button
            type='button'
            className={classnames('ms-cookie-compliance__accept-essential-button msc-btn', { 'is-loading': reloading })}
            aria-label={acceptEssentialCookiesButtonAriaLabel}
            disabled={reloading}
            onClick={onClose}
            {...attributes}
        >
            {acceptEssentialCookiesButtonText}
        </button>
    );
};
